import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  ConfirmPaymentRequest,
  ProcessPaymentResponse,
} from '@cashier/cashier-api-model';

import { PaymentActionMapper } from '../common/mapper';
import {
  confirmPaymentFailure,
  confirmPaymentStart,
  confirmPaymentSuccess,
} from './paymentConfirmation.slice';

export const paymentConfirmationEpic = (action$: any, state$: any, { Api }) =>
  action$.pipe(
    ofType(confirmPaymentStart.type),
    switchMap((action: { payload: ConfirmPaymentRequest }) =>
      Api.confirmPayment(action.payload).pipe(
        map(
          (data: ProcessPaymentResponse) =>
            confirmPaymentSuccess(
              PaymentActionMapper.toPaymentActionResult(data),
            ),
          catchError((err) =>
            of(
              confirmPaymentFailure(
                PaymentActionMapper.toPaymentActionError(err),
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const confirmPayment = (data: ConfirmPaymentRequest) => ({
  type: confirmPaymentStart.type,
  payload: data,
});
